<template>
  <div class="d-flex">
    <div class="cursor-pointer comment-icon" @click="openCommentsModal">
      <span class="unread-count" v-if="unreadComments > 0">{{
        unreadComments
      }}</span>
      <svg
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
        ></path>
      </svg>
    </div>
    <span>{{ data.name }}</span>
    <CommentsModal
      :company-id="data.id"
      :status-id="data.status_id"
      v-if="showComments"
      @closeModal="closeCommentsModal"
    />
  </div>
</template>

<script>
import CommentsModal from "./CommentsModal.vue";
import axios from "axios";
export default {
  components: { CommentsModal },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showComments: false,
      unreadComments: 0,
    };
  },
  mounted() {
    this.$eventBus.$on("closeAllCommentsModals", () => {
      this.showComments = false;
    });

    this.getUnreadComments();
  },
  methods: {
    openCommentsModal() {
      this.unreadComments = 0;
      this.$eventBus.$emit("closeAllCommentsModals");
      this.$nextTick(() => {
        this.showComments = !this.showComments;
      });
    },
    closeCommentsModal() {
      this.showComments = !this.showComments;
    },
    getUnreadComments() {
      axios
        .get(`/dashboard/admin/read-comments/${this.data.id}`)
        .then((response) => {
          this.unreadComments = response.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
svg {
  width: 18px;
  margin-right: 0.5rem;
}

.cursor-pointer {
  cursor: pointer;
}

.unread-count {
  font-size: 9px;
  background-color: red;
  width: 0.8rem;
  height: 0.8rem;
  display: block;
  border-radius: 1000px;
  color: white;
  position: absolute;
  margin-top: -5px;
  margin-left: -5px;
}
</style>